export default "__VITE_ASSET__984570c9__"